import { render, staticRenderFns } from "./SiteMenu.vue?vue&type=template&id=89839c1a&scoped=true&"
import script from "./SiteMenu.vue?vue&type=script&lang=ts&"
export * from "./SiteMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89839c1a",
  null
  
)

export default component.exports